module.exports = __webpack_public_path__ + "img/header.a2a9e635.png";